import { Link, useLocation } from "react-router-dom";
import { CalendarIcon, User, Sparkles, MessageSquare } from "lucide-react";

interface NavItem {
  path: string;
  label: string;
  icon: JSX.Element;
}

const BottomTabs = () => {
  const location = useLocation();
  
  const navItems: NavItem[] = [
    {
      path: "/chat",
      label: "Chat",
      icon: <MessageSquare className="h-5 w-5" />
    },
    {
      path: "/logs",
      label: "Logs",
      icon: <CalendarIcon className="h-5 w-5" />
    },
    {
      path: "/insights",
      label: "Insights",
      icon: <Sparkles className="h-5 w-5" />
    },
    {
      path: "/profile",
      label: "Me",
      icon: <User className="h-5 w-5" />
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-background shadow-up border-t border-gray-200 dark:border-primary/20 z-50"
         style={{ 
           paddingBottom: 'env(safe-area-inset-bottom)',
           height: 'calc(60px + env(safe-area-inset-bottom))',
           position: 'fixed',
           bottom: 0
         }}>
      <div className="flex justify-around h-[60px]">
        {navItems.map((item) => (
          <Link 
            key={item.path} 
            to={item.path}
            className={`flex flex-col items-center justify-center flex-1 transition-colors ${
              location.pathname === item.path 
                ? "text-primary"
                : "text-muted-foreground dark:text-foreground/70"
            }`}
          >
            {item.icon}
            <span className="text-xs mt-1">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default BottomTabs; 
